import { useQuery } from '@tanstack/react-query';
import { apiClient } from 'src/libs/axios';
import { QueryOptions } from 'src/libs/react-query';
import { leaderboardKeys } from './leaderboard-keys';

export interface Season {
  end_date: string;
  id: string;
  start_date: string;
}

export interface Response {
  leaderboards: Season[];
}

export const getPreviousLeaderboard = async () => {
  const response = await apiClient.get<Response>('/v1/public/user-leaderboard/available');

  return response.data;
};

export type UseGetAvailableBalanceLPOptions<TData, TError> = QueryOptions<
  Response,
  TError,
  Response,
  ReturnType<typeof leaderboardKeys.getPreviousLeaderboard>
>;

export const useGetPreviousLeaderboard = <TData = Response, TError = Error>(
  options?: UseGetAvailableBalanceLPOptions<TData, TError>,
) => {
  return useQuery({
    queryKey: leaderboardKeys.getPreviousLeaderboard(),
    queryFn: () => getPreviousLeaderboard(),
    enabled: true,
    ...options,
  });
};
